var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-sticky',[_c('van-nav-bar',{attrs:{"title":"公告"},scopedSlots:_vm._u([{key:"left",fn:function(){return [_c('van-icon',{attrs:{"name":"arrow-left"},on:{"click":function($event){_vm.$router.push(_vm.$cookie.get('prevPage') || '/')}}})]},proxy:true}])})],1),_c('div',{staticClass:"wrap",style:({
      backgroundImage:
        'url(' +
        _vm.$returnColor().path +
        (_vm.$store.state.selfData.member_id
          ? '/home-page_bg.png'
          : '/home-page_bg.png') +
        ')',
    })},[_vm._l((_vm.annList),function(list){return _c('van-cell-group',{key:list.id,staticStyle:{"margin-top":"10px"},attrs:{"inset":""},on:{"click":function($event){return _vm.showContent(list)}}},[_c('van-cell',{attrs:{"title":list.created_at,"label":list.title}})],1)}),(!_vm.annList.length)?_c('div',{staticClass:"noData"},[_vm._v("暂无公告")]):_vm._e()],2),_c('foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }